import { render, staticRenderFns } from "./TextEditorEmailCampaign.vue?vue&type=template&id=57e5ef7c&scoped=true&"
import script from "./TextEditorEmailCampaign.vue?vue&type=script&lang=js&"
export * from "./TextEditorEmailCampaign.vue?vue&type=script&lang=js&"
import style0 from "./TextEditorEmailCampaign.vue?vue&type=style&index=0&id=57e5ef7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e5ef7c",
  null
  
)

export default component.exports